<template>
  <div class="w-full">
    <FileUpload
      ref="fileUpload"
      name="demo[]"
      multiple
      :show-upload-button="false"
      choose-label="Selecteaza fisier"
      cancel-label="Sterge toate upload-urile"
      custom-upload
      severity="secondary"
      :max-file-size="maxFileSize"
      :accept="
        userSide
          ? '.docx,.dotx,.xlsx,.xlsm,.mpp,.mpt,.vsdx,.pptx,.ppsx,.jpg,.jpeg,.png,.pdf'
          : null
      "
      :pt="{
        filethumbnail: 'hidden',
        pcfilebadge: { root: 'hidden' },
      }"
      :choose-button-props="userSide ? { class: 'bg-secondary-color' } : {}"
      @select="onFileSelect"
      @remove="onFileSelect"
      @clear="$emit('update:files', [])"
    >
      <template #empty>
        <span>Trageți și plasați fișierele aici</span>
      </template>
    </FileUpload>
  </div>
</template>

<script>
import FileUpload from 'primevue/fileupload';

export default {
  components: {
    FileUpload,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    maxFileSize: {
      type: Number,
      default: null,
    },
    userSide: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:files'],
  methods: {
    onFileSelect(event) {
      this.$emit('update:files', event.files);
    },
  },
};
</script>
